module.exports = __webpack_public_path__ + "static/media/SDFSA_7-960w.562d069b.jpg";